import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import DocumentTitle from 'react-document-title'

import InvoicingEntitiesStore from './invoicing-entities.store'

import FilterGroup from '@components/FilterGroup'
import InvoicingTable from './InvoicingEntitiesTable'
import ReloadIcon from '@components/Icon/Reload'
import Error from '@components/Error/NoContent'
import Spinner from '@components/spinner'
import Actions from './Actions'

class InvoicingEntitiesTab extends Component {
  static propTypes = {
    parentAccount: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,
    staticData: PropTypes.object,
    growlStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      invoicingEntitiesStore: new InvoicingEntitiesStore(
        props.staticData,
        props.growlStore
      )
    })

    const { parentAccount } = props
    this.invoicingEntitiesStore.loadInvoicingEntities(parentAccount.id)
  }

  filter (e) {
    if (e.keyCode === 13) {
      this.invoicingEntitiesStore.filter()
    }
  }

  clearFilter = () => {
    this.invoicingEntitiesStore.clearSearch(this.props.parentAccount.id)
    this.invoicingEntitiesStore.filter()
  }

  render () {
    const {
      invoicingEntitiesCount,
      error,
      loading,
      query
    } = this.invoicingEntitiesStore

    const { parentAccount } = this.props
    if (error) {
      return <Error />
    }
    if (loading) {
      return <Spinner />
    }
    const matchUrl = this.props.match.url
    return (
      <DocumentTitle
        title={`${parentAccount.parentAccountName} - invoicing entities | Atheneum Partners`}
      >
        <div className='views-wrapper'>
          <div className='details-wrapper animate-intro'>
            <Actions parentAccount={parentAccount} />
          </div>
          <div className='project-search-bar'>
            <FilterGroup inView label='Legal name' labelClass='code-label'>
              <input
                className='contracts-code-input'
                onKeyDown={e => {
                  this.filter(e)
                }}
                onChange={e =>
                  (this.invoicingEntitiesStore.query.legalName = e.target.value)
                }
                value={query.legalName}
                onBlur={() => this.invoicingEntitiesStore.filter()}
              />
            </FilterGroup>
            <FilterGroup inView label='GL code' labelClass='code-label'>
              <input
                onKeyDown={e => {
                  this.filter(e)
                }}
                onChange={e =>
                  (this.invoicingEntitiesStore.query.glCode = e.target.value)
                }
                value={query.glCode}
                onBlur={() => this.invoicingEntitiesStore.filter()}
              />
            </FilterGroup>
            <FilterGroup inView label='Country' labelClass='code-label'>
              <input
                className='contracts-code-input'
                onKeyDown={e => {
                  this.filter(e)
                }}
                onChange={e =>
                  (this.invoicingEntitiesStore.query.country = e.target.value)
                }
                value={query.country}
                onBlur={() => this.invoicingEntitiesStore.filter()}
              />
            </FilterGroup>
            <div
              className='search-panel-container__title--action'
              onClick={this.clearFilter}
            >
              <ReloadIcon />
              <span className='row--link m-l-sm'>Clear filter</span>
            </div>
          </div>
          {invoicingEntitiesCount ? (
            <InvoicingTable
              baseUrl={matchUrl}
              invoicingEntitiesStore={this.invoicingEntitiesStore}
            />
          ) : (
            <Error
              label={'There are no invoicing entities for this parent account'}
            />
          )}
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(
  inject('staticData', 'growlStore')(observer(InvoicingEntitiesTab))
)
